import { withSuspenseLazy } from '@metrika/ui-kit';
export * from './Login';
export * from './Cookie';

export const TermsLazy = withSuspenseLazy(() => import('./Privacy/Terms'));

export const PrivacyLazy = withSuspenseLazy(() => import('./Privacy/Privacy'));
